import { render, staticRenderFns } from "./CartWorkspace.vue?vue&type=template&id=1f34aaed&scoped=true&"
import script from "./CartWorkspace.vue?vue&type=script&lang=js&"
export * from "./CartWorkspace.vue?vue&type=script&lang=js&"
import style0 from "../../styles/cart-workspace.css?vue&type=style&index=0&id=1f34aaed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f34aaed",
  null
  
)

export default component.exports